var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": _vm.label
    },
    model: {
      value: _vm.phone1,
      callback: function callback($$v) {
        _vm.phone1 = $$v;
      },
      expression: "phone1"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _vm._v(" - "), _c('v-col', [_c('v-text-field', _vm._b({
    model: {
      value: _vm.phone2,
      callback: function callback($$v) {
        _vm.phone2 = $$v;
      },
      expression: "phone2"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _vm._v(" - "), _c('v-col', [_c('v-text-field', _vm._b({
    model: {
      value: _vm.phone3,
      callback: function callback($$v) {
        _vm.phone3 = $$v;
      },
      expression: "phone3"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }